export default __webpack_public_path__ + "static/media/RILAC-Logo.14581a33.svg";